import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectContract, selectPreviousActiveCase } from '../../../redux/contract/selectors';
import { postTaxonomy } from '../../../redux/taxonomies/thunks';
import { selectTaxonomy } from '../../../redux/taxonomies/selectors';
import { selectCaseStates, selectCaseStatesLoading } from '../../../redux/caseStates/selectors';
import { getCaseStates } from '../../../redux/caseStates/thunks';
import { getTemplates } from '../../../redux/templates/thunks';
import { selectTemplates } from '../../../redux/templates/selectors';
import { selectEntryChannels } from '../../../redux/entryChannels/selectors';
import { CommentSection } from './CommentSection';
import { Header } from './header/Header';
import { TaxonomyForm } from './TaxonomyForm';
import { updateCase, createCase, newCase, getContractByCaseId, getCommentByCaseId, updateContractData, attachIdtProcessToCase } from '../../../redux/contract/thunks';
import { openModal } from '../../../redux/modal/modalSlice';
import { clearTaxonomyFields } from '../../../redux/taxonomies/taxonomySlice';
import { convertToUTC, convertToLocalTime, deleteStrangeCharacters, _base64ToArrayBuffer } from '../../../commonFunctions/commonFunctions';
import { NoneSelectedMessage } from '../../common/NoneSelected';
import { QUERY_POST_SMS, QUERY_POST_EMAIL, QUERY_GET_EMAIL_FROM_TEMPLATE, QUERY_POST_EMAIL_EXTERNAL } from '../../../fetch/constantQueries';
import DocumentationForm from './forms/documentation/DocumentationForm';
import { baseRequest } from '../../../fetch/basicThunk';
import { removeActiveHistory, updateExceptionChecked } from '../../../redux/contract/contractSlice';
import { clearCurrentCase, updateCaseForm, setPreviousCaseState } from '../../../redux/currentCase/currentCaseSlice';
import {
  setFormAppointment,
  setFormDocumentation,
  setFormClaims,
  setFormInformation,
  setFormTerminations,
  setFormSubstitutionVehicle,
  setFormDelivery,
  setFormOvc,
  setFormItv,
} from '../../../redux/caseForms/caseFormSlice';
import { isCaseBlockedByUser } from '../../../redux/cases/thunks';
import { blockCase, unBlockCase, updateClickToCall } from '../../../redux/currentCase/thunks';
import { selectWorkshopSearchResults, selectWorkshopSearchLoading, selectWorkshopSearchFilters } from '../../../redux/workshopSearch/selectors';
import dayjs from 'dayjs';
import { selectCallId } from '../../../redux/appState/selectors';
import { getEntryChannels } from '../../../redux/entryChannels/thunks';
import { getWorkshopTypes } from '../../../redux/workshopTypes/thunks';
import { selectWorkshopTypes } from '../../../redux/workshopTypes/selectors';
import { selectCurrentCase, selectCurrentCaseLoading } from '../../../redux/currentCase/selectors';
import {
  selectFormAppointment,
  selectFormDocumentation,
  selectFormClaims,
  selectFormInformation,
  selectFormTerminations,
  selectFormSubstitutionVehicle,
  selectFormDelivery,
  selectFormOvc,
  selectFormItv,
} from '../../../redux/caseForms/selectors';
import CallTable from '../CallTable/CallTable';
import { getActionResolutions } from '../../../redux/actionResolutions/thunks';
import { selectActionResolutions } from '../../../redux/actionResolutions/selectors';
import MessageForm from '../message/MessageForm';
import { AddFactoryCommentForm } from '../factoryCaseForm/AddFactoryCommentForm';
import { AdvanceFactoryCaseForm } from '../factoryCaseForm/AdvanceFactoryCaseForm';
import { CaseStates } from '../../../Constantes/CaseStates';

import { SmsFormTypeIds } from '../../../Constantes/smsFormTypes';

function CaseWrapper(props) {
  const dispatch = useDispatch();
  const contract = useSelector(selectContract);
  const workshopSearch = useSelector(selectWorkshopSearchResults);
  const workshopFilters = useSelector(selectWorkshopSearchFilters);
  const currentCase = useSelector(selectCurrentCase);
  const loadingWorkshopSearch = useSelector(selectWorkshopSearchLoading);
  const loadingCase = useSelector(selectCurrentCaseLoading);
  const taxonomyOptions = useSelector(selectTaxonomy);
  const caseStateOptions = useSelector(selectCaseStates);
  const entryChannelsOptions = useSelector(selectEntryChannels);
  const templates = useSelector(selectTemplates);
  const workshopTypes = useSelector(selectWorkshopTypes);
  const caseStateOptionsLoading = useSelector(selectCaseStatesLoading);
  const previousActive = useSelector(selectPreviousActiveCase);
  const callId = useSelector(selectCallId);
  const actionResolutionOptions = useSelector(selectActionResolutions);
  const [reloadTaxonomies, setReloadTaxonomies] = useState(true);
  const [disabledButtom, setDisabledButtom] = useState({ documentation: true, messageForm: true, advanceFactoryCase: true, addFactoryComment: true });
  const [taxonomyValues, setTaxonomyValues] = useState({ level: undefined, taxonomyLevel_1: '', taxonomyLevel_2: '', taxonomyLevel_3: '', taxonomyLevel_4: '' });
  const [caseStateValue, setCaseStateValue] = useState('');
  const [scheduleDate, setScheduleDate] = useState(undefined);
  const [scaleDate, setScaleDate] = useState(undefined);
  const [factoryCloseDate, setFactoryCloseDate] = useState(undefined);
  const [nonPPReason, setNonPPReason] = useState('');
  const [comment, setCaseComment] = useState('');
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [caseNumber, setCaseNumber] = useState('');
  const [entryChannel, setEntryChannel] = useState('');
  const [actionResolution, setActionResolution] = useState(null);
  const [subState, setSubStateValue] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');

  const [showNewCase, setShowNewCase] = useState(currentCase?.caseId === 0);
  const [closed, setClosed] = useState();
  const [showMessageForm, setshowMessageForm] = useState(false);
  const [showDocumentation, setShowDocumentation] = useState(false);
  const [showCallTable, setShowCallTable] = useState(false);
  const [editClickToCall, setEditClickToCall] = useState(false);
  const [showAdvanceFactoryCaseForm, setShowAdvanceFactoryCaseForm] = useState(false);
  const [showAddFactoryCommentForm, setShowAddFactoryCommentForm] = useState(false);
  const [showRegressFactoryCaseForm, setShowRegressFactoryCaseForm] = useState(false);
  const [replacedSms, setReplacedSms] = useState(null);

  const [updatePauPhone, setUpdatePauPhone] = useState();
  const [disabledRegressCase, setDisabledRegressCase] = useState(false);

  const [formType, setFormType] = useState('');
  const [dataSms, setDataSms] = useState({
    number: '',
    contentSms: '',
    template: templates[0],
    plate: contract.plate != null ? contract.plate : '',
    CNPJ: contract.customerCNPJ != null ? contract.customerCNPJ : '',
    workshopId: '',
    appointmentDate: null,
    workshopType: workshopFilters?.searchOption || '',
    email: '', //contract.contractData?.email ? contract.contractData.email : '',
    city: '',
    office: '',
    numberReference: '',
    sendMail: false,
  });
  const [dataForm, setDataForm] = useState({});

  const [dataDocumentation, setDataDocumentation] = useState({
    template: null,
    plate: contract.plate != null ? contract.plate : '',
    CNPJ: contract.customerCNPJ != null ? contract.customerCNPJ : '',
  });

  const dataFormAppointment = useSelector(selectFormAppointment);
  const dataFormDocumentation = useSelector(selectFormDocumentation);
  const dataFormClaims = useSelector(selectFormClaims);
  const dataFormInformation = useSelector(selectFormInformation);
  const dataFormTerminations = useSelector(selectFormTerminations);
  const dataFormSubstitutionVehicle = useSelector(selectFormSubstitutionVehicle);
  const dataFormDelivery = useSelector(selectFormDelivery);
  const dataFormOvc = useSelector(selectFormOvc);
  const dataFormItv = useSelector(selectFormItv);

  const [dataEmailForm, setDataEmailForm] = useState({
    email: '',
    cc: '',
    urgent: false,
    plate: contract.plate != null ? contract.plate : '',
    CNPJ: contract.customerCNPJ != null ? contract.customerCNPJ : '',
    number: '',
    name: '',
    surnames: '',
    workshopId: '',
    workshopType: workshopFilters?.searchOption || '',
    appointmentDate: null,
    subject: '',
    stationId: '',

    attachments: [],
  });

  // Gestiona el cambio de plantilla

  function handleTemplateChange(e) {
    let workshopType = '';
    if (workshopFilters?.searchOption) {
      const { workshopTypeId } = workshopTypes.workshopTypes.find((w) => w.workshopType === workshopFilters.searchOption);
      workshopType = workshopTypeId;
    }

    if (formType == 'messageForm') {
      setDataSms((prevState) => ({
        ...prevState,
        contentSms: e?.text,
        template: e,
        workshopType: workshopType ?? '',
        sendMail: false,
      }));

      setDataEmailForm((prevState) => ({
        ...prevState,
        template: e,
        contentEmail: e?.text,
        subject: e?.subject ?? '', // e?.templateTypeId === SmsFormTypeIds.external_email ? e?.subject ?? '' : '',
        workshopId: '',
        workshopType: workshopType ?? '',
        appointmentDate: null,
        attachments: [],
      }));
    } else {
      let preloadedFields = {
        email: '', //contract.contractData?.email ? contract.contractData.email : '',
      };
      if (e?.code === 'workshop_appointment') {
        //if(contract.unassigned || !contract.plate){
        if (contract.unassigned || !contract.CNPJ) {
          dispatch(openModal({ type: 'warning', message: 'Para utilizar esta plantilla debe asignar una matrícula al caso.' }));
          setDataForm({});
          dispatch(setFormAppointment({}));
          dispatch(setFormDocumentation({}));
          dispatch(setFormClaims({}));
          dispatch(setFormInformation({}));
          dispatch(setFormTerminations({}));
          dispatch(setFormSubstitutionVehicle({}));
          dispatch(setFormDelivery({}));
          dispatch(setFormOvc({}));
          dispatch(setFormItv({}));

          setDataDocumentation((prevState) => ({
            ...prevState,
            template: null,
          }));
          return;
        }

        const preloadedPhoneNumber = contract.contractData?.mobilePhone || phoneNumber;

        preloadedFields = {
          ...preloadedFields,
          name: contract.contractData?.userName || '',
          surname: contract.contractData?.userSurnames || '',
          phoneNumber: preloadedPhoneNumber,
          orangeLightPilot: false,
          itvBonus: false,
          originalDocItv: false,
          numberOfTyres: 2,
          tyrePosition: 'Delantero',
        };
      }

      setDataForm(preloadedFields);

      const preloadedFieldsWorkshopAppointment = {
        //email: dataFormAppointment?.email && dataFormAppointment?.email != '' ? dataFormAppointment?.email : contract.contractData?.email ? contract.contractData.email : '',
        name: dataFormAppointment?.name && dataFormAppointment?.name != '' ? dataFormAppointment?.name : contract.contractData?.userName || '',
        surname: dataFormAppointment?.surname && dataFormAppointment?.surname != '' ? dataFormAppointment?.surname : contract.contractData?.userSurnames || '',
        phoneNumber: dataFormAppointment?.phoneNumber && dataFormAppointment?.phoneNumber != '' ? dataFormAppointment?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
        tyreSize: dataFormAppointment?.tyreSize && dataFormAppointment?.tyreSize != '' ? dataFormAppointment?.tyreSize : '',
        orangeLightPilot: dataFormAppointment?.orangeLightPilot ? dataFormAppointment?.orangeLightPilot : false,
        itvBonus: dataFormAppointment?.itvBonus ? dataFormAppointment?.itvBonus : false,
        originalDocItv: dataFormAppointment?.originalDocItv ? dataFormAppointment?.originalDocItv : false,
        numberOfTyres: dataFormAppointment?.numberOfTyres ? dataFormAppointment?.numberOfTyres : 2,
        tyrePosition: dataFormAppointment?.tyrePosition ? dataFormAppointment?.tyrePosition : 'Delantero',
      };

      dispatch(setFormAppointment({ ...dataFormAppointment, ...preloadedFieldsWorkshopAppointment }));

      const preloadedFieldsDocumentation = {
        //email: dataFormDocumentation?.email && dataFormDocumentation?.email != '' ? dataFormDocumentation?.email : contract.contractData?.email ? contract.contractData.email : '',
        name: dataFormDocumentation?.name && dataFormDocumentation?.name != '' ? dataFormDocumentation?.name : contract.contractData?.userName || '',
        surname: dataFormDocumentation?.surname && dataFormDocumentation?.surname != '' ? dataFormDocumentation?.surname : contract.contractData?.userSurnames || '',
        phoneNumber: dataFormDocumentation?.phoneNumber && dataFormDocumentation?.phoneNumber != '' ? dataFormDocumentation?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
        dni: dataFormDocumentation?.dni && dataFormDocumentation?.dni != '' ? dataFormDocumentation?.dni : contract.contractData ? contract.contractData?.licenseNumber : '',
      };

      dispatch(setFormDocumentation({ ...dataFormDocumentation, ...preloadedFieldsDocumentation }));

      const preloadClaimsData = {
        name: dataFormClaims?.name && dataFormClaims?.name !== '' ? dataFormClaims.name : contract.contractData?.userName || '',
        surname: dataFormClaims?.surname && dataFormClaims?.surname !== '' ? dataFormClaims.surname : contract.contractData?.userSurnames || '',
        phoneNumber: dataFormClaims?.phoneNumber && dataFormClaims?.phoneNumber !== '' ? dataFormClaims.phoneNumber : contract.contractData?.mobilePhone || '',
        templateId: null,
        notes: dataFormClaims?.notes && dataFormClaims?.notes !== '' ? dataFormClaims.notes : contract.contractData?.notes || '',
        //email: dataFormClaims?.email && dataFormClaims?.email?.trim() !== '' ? dataFormClaims.email : contract.contractData?.email ?? '',
        urgent: dataFormClaims?.urgent ?? false,
        workshopEntry: dataFormClaims?.workshopEntry ?? null,
        immobilizationReason: dataFormClaims?.immobilizationReason ?? '',
        immobilizationTime: dataFormClaims?.immobilizationTime ?? null,
      };

      dispatch(setFormClaims({ ...dataFormClaims, ...preloadClaimsData }));

      const preloadDeliveryData = {
        name: preloadDeliveryData?.name && dataFormDelivery?.name !== '' ? dataFormDelivery.name : contract.contractData?.userName || '',
        surname: dataFormDelivery?.surname && dataFormDelivery?.surname !== '' ? dataFormDelivery.surname : contract.contractData?.userSurnames || '',
        phoneNumber: dataFormDelivery?.phoneNumber && dataFormDelivery?.phoneNumber !== '' ? dataFormDelivery.phoneNumber : contract.contractData?.mobilePhone || '',
        templateId: null,
        notes: dataFormDelivery?.notes && dataFormDelivery?.notes !== '' ? dataFormDelivery.notes : contract.contractData?.notes || '',
        //email: dataFormDelivery?.email && dataFormDelivery?.email?.trim() !== '' ? dataFormDelivery.email : contract.contractData?.email ?? '',
      };

      dispatch(setFormDelivery({ ...dataFormDelivery, ...preloadDeliveryData }));

      const preloadedFieldsInformation = {
        //email: dataFormInformation?.email && dataFormInformation?.email != '' ? dataFormInformation?.email : contract.contractData?.email ? contract.contractData.email : '',
        name: dataFormInformation?.name && dataFormInformation?.name != '' ? dataFormInformation?.name : contract.contractData?.userName || '',
        surname: dataFormInformation?.surname && dataFormInformation?.surname != '' ? dataFormInformation?.surname : contract.contractData?.userSurnames || '',
        phoneNumber: dataFormInformation?.phoneNumber && dataFormInformation?.phoneNumber != '' ? dataFormInformation?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
        dni: dataFormInformation?.dni && dataFormInformation?.dni != '' ? dataFormInformation?.dni : contract.contractData ? contract.contractData?.licenseNumber : '',
      };

      dispatch(setFormInformation({ ...dataFormInformation, ...preloadedFieldsInformation }));

      const preloadedFieldsTerminations = {
        //email: dataFormTerminations?.email && dataFormTerminations?.email != '' ? dataFormTerminations?.email : contract.contractData?.email ? contract.contractData.email : '',
        name: dataFormTerminations?.name && dataFormTerminations?.name != '' ? dataFormTerminations?.name : contract.contractData?.userName || '',
        surname: dataFormTerminations?.surname && dataFormTerminations?.surname != '' ? dataFormTerminations?.surname : contract.contractData?.userSurnames || '',
        phoneNumber: dataFormTerminations?.phoneNumber && dataFormTerminations?.phoneNumber != '' ? dataFormTerminations?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
        dni: dataFormTerminations?.dni && dataFormTerminations?.dni != '' ? dataFormTerminations?.dni : contract.contractData ? contract.contractData?.licenseNumber : '',
      };

      dispatch(setFormTerminations({ ...dataFormTerminations, ...preloadedFieldsTerminations }));

      const preloadedFieldsSubstitutionVehicle = {
        //email: dataFormSubstitutionVehicle?.email && dataFormSubstitutionVehicle?.email != '' ? dataFormSubstitutionVehicle?.email : contract.contractData?.email ? contract.contractData.email : '',
        name: dataFormSubstitutionVehicle?.name && dataFormSubstitutionVehicle?.name != '' ? dataFormSubstitutionVehicle?.name : contract.contractData?.userName || '',
        surname: dataFormSubstitutionVehicle?.surname && dataFormSubstitutionVehicle?.surname != '' ? dataFormSubstitutionVehicle?.surname : contract.contractData?.userSurnames || '',
        phoneNumber:
          dataFormSubstitutionVehicle?.phoneNumber && dataFormSubstitutionVehicle?.phoneNumber != '' ? dataFormSubstitutionVehicle?.phoneNumber : contract.contractData?.mobilePhone || phoneNumber,
      };

      dispatch(setFormSubstitutionVehicle({ ...dataFormSubstitutionVehicle, ...preloadedFieldsSubstitutionVehicle }));

      const preloadedFieldsOvc = {
        name: dataFormOvc?.name && dataFormOvc?.name != '' ? dataFormOvc?.name : contract.contractData?.userName || '',
        surname: dataFormOvc?.surname && dataFormOvc?.surname != '' ? dataFormOvc?.surname : contract.contractData?.userSurnames || '',
        //email: dataFormOvc?.email && dataFormOvc?.email != '' ? dataFormOvc?.email : contract.contractData?.email ? contract.contractData?.email : '',
        phoneNumber:
          dataFormOvc?.phoneNumber && dataFormOvc?.phoneNumber != ''
            ? dataFormOvc?.phoneNumber
            : contract.contractData?.mobilePhone?.trim() !== ''
            ? contract.contractData?.mobilePhone
            : phoneNumber || '',
        dni: dataFormOvc?.dni && dataFormOvc?.dni != '' ? dataFormOvc?.dni : contract.contractData ? contract.contractData?.licenseNumber : '',
      };

      dispatch(setFormOvc({ ...dataFormOvc, ...preloadedFieldsOvc }));

      const preloadedFieldsItv = {
        name: dataFormItv?.name && dataFormItv?.name != '' ? dataFormItv?.name : contract.contractData?.userName || '',
        surname: dataFormItv?.surname && dataFormItv?.surname != '' ? dataFormItv?.surname : contract.contractData?.userSurnames || '',
        //email: dataFormItv?.email && dataFormItv?.email != '' ? dataFormItv?.email : contract.contractData?.email ? contract.contractData?.email : '',
        phoneNumber:
          dataFormItv?.phoneNumber && dataFormItv?.phoneNumber != ''
            ? dataFormItv?.phoneNumber
            : contract.contractData?.mobilePhone?.trim() !== ''
            ? contract.contractData?.mobilePhone
            : phoneNumber || '',
      };

      dispatch(setFormItv({ ...dataFormItv, ...preloadedFieldsItv }));

      setDataDocumentation((prevState) => ({
        ...prevState,
        template: e,
      }));
    }
  }

  useEffect(() => {
    if (contract.contractData) {
      setDataForm((prevState) => ({
        ...prevState,
        name: contract.contractData?.userName ? contract.contractData.userName : '',
        surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
        //email: contract.contractData?.email ? contract.contractData.email : '',
        phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
      }));
      setDataSms((prevState) => ({ ...prevState, number: phoneNumber ? phoneNumber : contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : '' }));
      dispatch(
        setFormAppointment({
          ...dataFormAppointment,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
        })
      );
      dispatch(
        setFormDocumentation({
          ...dataFormDocumentation,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
          dni: contract.contractData ? contract.contractData?.licenseNumber : '',
        })
      );
      dispatch(
        setFormClaims({
          ...dataFormClaims,
          name: contract.contractData?.userName ?? '',
          surname: contract.contractData?.userSurnames ?? '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
          notes: '',
          //email: contract.contractData?.email ?? '',
          urgent: false,
          workshopEntry: null,
          immobilizationReason: '',
          immobilizationTime: null,
        })
      );
      dispatch(
        setFormDelivery({
          ...dataFormDelivery,
          name: contract.contractData?.userName ?? '',
          surname: contract.contractData?.userSurnames ?? '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
          notes: '',
          //email: contract.contractData?.email ?? '',
        })
      );
      dispatch(
        setFormInformation({
          ...dataFormInformation,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
          dni: contract.contractData ? contract.contractData?.licenseNumber : '',
        })
      );
      dispatch(
        setFormTerminations({
          ...dataFormTerminations,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
          dni: contract.contractData ? contract.contractData?.licenseNumber : '',
        })
      );
      dispatch(
        setFormSubstitutionVehicle({
          ...dataFormSubstitutionVehicle,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
        })
      );
      dispatch(
        setFormOvc({
          ...dataFormOvc,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
          dni: contract.contractData ? contract.contractData?.licenseNumber : '',
        })
      );
      dispatch(
        setFormItv({
          ...dataFormItv,
          name: contract.contractData?.userName ? contract.contractData.userName : '',
          surname: contract.contractData?.userSurnames ? contract.contractData.userSurnames : '',
          //email: contract.contractData?.email ? contract.contractData.email : '',
          phoneNumber: contract.contractData?.mobilePhone?.trim() !== '' ? contract.contractData?.mobilePhone : phoneNumber || '',
        })
      );
    }
  }, [contract.contractData, phoneNumber]);

  //Mostrar formularios
  function handleShowForms(type) {
    setDataEmailForm((prevState) => ({
      attachments: [],
    }));

    setFormType(type);
    if (type == 'callTable') {
      setShowCallTable(!showCallTable);
      setshowMessageForm(false);
      setShowDocumentation(false);
      setShowAdvanceFactoryCaseForm(false);
      setShowAddFactoryCommentForm(false);
      return;
    } else {
      setShowCallTable(false);
    }

    if (!disabledButtom[type]) {
      if (contract.customerCNPJ || currentCase.withoutPlate) {
        dispatch(isCaseBlockedByUser({ query: `?caseId=${currentCase.caseId}` })).then((data) => {
          if (data.payload) {
            setshowMessageForm(type != 'messageForm' ? false : !showMessageForm);
            setShowDocumentation(type != 'documentation' ? false : !showDocumentation);
            setShowAdvanceFactoryCaseForm(type != 'advanceFactoryCase' ? false : !showAdvanceFactoryCaseForm);
            setShowAddFactoryCommentForm(type != 'addFactoryComment' ? false : !showAddFactoryCommentForm);
            setShowRegressFactoryCaseForm(type != 'regressFactoryCase' ? false : !showRegressFactoryCaseForm);
          } else if (data.payload === false) {
            dispatch(openModal({ type: 'warning', message: 'El caso esta bloqueado por otro usuario.' }));
          }
        });
      } else {
        setshowMessageForm(false);
        setShowDocumentation(false);
        setShowAdvanceFactoryCaseForm(false);
        setShowAddFactoryCommentForm(false);
        setShowRegressFactoryCaseForm(false);
      }
    }
  }

  //Gestiona el cambio en el SMS
  function handleChangeSendSMSForm(field, value) {
    setDataSms((prevState) => ({ ...prevState, [field]: value }));
  }

  //Mantiene el tipo de taller del sms sincronizado con el formulario de búsqueda
  useEffect(() => {
    if (workshopFilters?.searchOption) {
      const { workshopTypeId } = workshopTypes.workshopTypes.find((w) => w.workshopType === workshopFilters.searchOption);
      setDataSms((prevState) => ({
        ...prevState,
        workshopType: workshopTypeId,
      }));
    }
  }, [workshopFilters]);

  async function updatePauData(dataDoct) {
    const contractHasPauData = contract.contractData ? true : false;
    const hasNewMobilePhone = contractHasPauData && dataDoct.number && dataDoct.number.trim() !== contract.contractData?.mobilePhone;

    if ((!contractHasPauData || hasNewMobilePhone) && updatePauPhone) {
      const submitData = {
        contractDataId: contract.contractData?.contractDataId,
        userName: contract.contractData?.userName,
        userSurnames: contract.contractData?.userSurnames,
        mobilePhone: hasNewMobilePhone || !contractHasPauData ? dataDoct.number : contract.contractData?.mobilePhone,
        phone: contract.contractData?.phone,
        //email: contract.contractData?.email,
        driversClub: contract.contractData?.driversClub,
        driversClubDate: contract.contractData?.driversClubDate ? dayjs(contract.contractData?.driversClubDate, 'DD/MM/YYYY').format('YYYY/MM/DD') : null,
        kilometrage: contract.contractData?.kilometrage,
        licenseNumber: contract.contractData?.licenseNumber,
      };

      await dispatch(updateContractData({ param: contract.id, body: submitData }));
    }
  }

  //Evento de envio de SMS
  async function handleSendSmsForm() {
    if (!dataSms.template.templateId) {
      dispatch(openModal({ type: 'warning', message: 'Es obligatorio seleccionar una plantilla.' }));
    }
    if (dataSms.number == null || dataSms.number == '') {
      dispatch(openModal({ type: 'warning', message: 'El número de telefóno es obligatorio.' }));
    } else if ((dataSms.contentSms == null || dataSms.contentSms == '') && dataSms.template != null && dataSms.template.type != 'Certificado') {
      dispatch(openModal({ type: 'warning', message: 'El mensaje del SMS no puede estar vacío.' }));
    } else if (dataSms.template != undefined && dataSms.template.type == 'Certificado' && (dataSms.workshopId == null || dataSms.workshopId == '')) {
      dispatch(openModal({ type: 'warning', message: 'El taller no puede estar vacío.' }));
    } else if (dataSms.template != undefined && dataSms.template.type == 'Certificado' && (dataSms.workshopType == null || dataSms.workshopType == '')) {
      dispatch(openModal({ type: 'warning', message: 'El tipo de taller no puede estar vacío.' }));
    } else if (
      dataSms.template != undefined &&
      dataSms.template.type == 'Certificado' &&
      (dataSms.appointmentDate == null || dataSms.appointmentDate == '') &&
      dataSms.template.name == 'Cita Taller'
    ) {
      dispatch(openModal({ type: 'warning', message: 'La fecha de la cita no puede estar vacía.' }));
    } else if (dataSms.template != undefined && dataSms.template.type == 'Certificado' && (dataSms.plate == null || dataSms.plate == '')) {
      dispatch(openModal({ type: 'warning', message: 'La matrícula no puede estar vacía.' }));
    } else {
      const prevButtonsState = { ...disabledButtom };
      setAllButtonsToState({ disabled: true });
      const submitData = {
        numbers: [dataSms.number],
        text: replacedSms ? replacedSms : dataSms.contentSms,
        workshopId: dataSms.workshopId,
        workshopType: dataSms.workshopType?.toString(),
        plate: dataSms.plate ? dataSms.plate : currentCase.plate === null ? '' : currentCase.plate,
        smsType: dataSms.template == undefined || dataSms.template.type == null ? 'Normal' : dataSms.template.type,
        caseId: currentCase.caseId.toString(),
        templateId: dataSms.template.templateId,
        appointmentDate: dataSms.appointmentDate != null ? dayjs(dataSms.appointmentDate).format('DD/MM/YYYY HH:mm') : '',
        email: dataSms.email,
        stationId: dataSms.stationId,
        date: dataSms.date,
        sendAssociatedEmail: dataSms.sendMail,
      };
      try {
        await baseRequest({ body: submitData }, dispatch, QUERY_POST_SMS, 'POST');
        const successMessage = submitData.sendAssociatedEmail ? 'SMS + Email enviado' : 'SMS enviado';
        dispatch(openModal({ type: 'success', message: successMessage }));
        dispatch(getCommentByCaseId({ query: `?caseId=${currentCase.caseId}` }));
        setshowMessageForm(false);

        updatePauData(dataSms);
        setDataSms((prevState) => ({
          number:
            currentCase != null && currentCase.phoneNumber != null
              ? currentCase.phoneNumber
              : contract.contractData == null
              ? contract.customerPhone == null
                ? ''
                : contract.customerPhone
              : contract.contractData.mobilePhone,
          plate: contract.plate != null ? contract.plate : '',
          contentSms: '',
          smsType: '',
          appointmentDate: null,
          workshopType: null,
          sendMail: false,
        }));

        const shouldUpdatePauPhoneWhenSaving = currentCase != null && currentCase.phoneNumber != null;
        setUpdatePauPhone(shouldUpdatePauPhoneWhenSaving);
      } catch (error) {
      } finally {
        setDisabledButtom(prevButtonsState);
      }
    }
  }

  //Evento de envío de email
  async function handleSendEmailForm(internal) {
    const prevButtonsState = { ...disabledButtom };
    setAllButtonsToState({ disabled: true });

    const recipientsIntoArray = dataEmailForm.email ? dataEmailForm.email.split(';') : [];
    const ccEmailsIntoArray = dataEmailForm.cc?.split(';') ?? [];

    const submitData = {
      addresses: recipientsIntoArray,
      ccAddresses: ccEmailsIntoArray, //dataEmailForm.template?.templateTypeId === SmsFormTypeIds.external_email ? [] : ccEmailsIntoArray,
      templateId: dataEmailForm.template?.templateId,
      contentEmail: dataEmailForm.contentEmail,
      name: dataEmailForm.name,
      surnames: dataEmailForm.surnames,
      phone: dataEmailForm.phoneNumber,
      lastComment: SmsFormTypeIds.internal_email == dataEmailForm.template?.templateTypeId,
      subject: dataEmailForm.subject,
      caseId: currentCase.caseId,
      number: null,
      email: internal ? '' : recipientsIntoArray.length > 0 ? recipientsIntoArray[0] : contract.contractData?.email ?? '',
      sendMail: true,
      plate: dataEmailForm.plate,
      model: contract.model && contract.model.length > 0 ? `${contract.brand} - ${contract.model}` : contract.brand,
      workshopId: dataEmailForm.workshopId,
      workshopType: (dataEmailForm.workshopType ?? '').toString(),
      appointmentDate: dataEmailForm.appointmentDate != null ? dayjs(dataEmailForm.appointmentDate).format('DD/MM/YYYY HH:mm') : '',
      stationId: (dataEmailForm.stationId ?? '').toString(),
      attachments: dataEmailForm.attachments,
    };

    if (!validateEmailForm(submitData, dataEmailForm.template)) {
      setDisabledButtom(prevButtonsState);
      return;
    }

    let url = QUERY_POST_EMAIL;
    if (dataEmailForm.template?.templateTypeId == SmsFormTypeIds.external_email) url = QUERY_POST_EMAIL_EXTERNAL;

    let submitFormData = new FormData();
    Object.keys(submitData).forEach(function (key) {
      if (key.toLowerCase() !== 'attachments') {
        submitFormData.append(key, submitData[key]);
      } else {
        if (submitData[key]) {
          for (let file of submitData[key]) {
            submitFormData.append('Attachments', file);
          }
        }
      }
    });

    try {
      //await baseRequest({ body: submitData }, dispatch, url, 'POST');
      await baseRequest({ body: submitFormData, excludeContentType: true }, dispatch, url, 'POST');

      dispatch(openModal({ type: 'success', message: 'Email enviado.' }));
      dispatch(getCommentByCaseId({ query: `?caseId=${currentCase.caseId}` }));
      updatePauData(submitData);
      setshowMessageForm(false);
      setDataEmailForm((prevState) => ({
        template: null,
        urgent: false,
        contentEmail: null,
        subject: '',
        workshopId: '',
        workshopType: '',
        appointmentDate: null,
        attachments: [],
      }));
    } catch (error) {
    } finally {
      setDisabledButtom(prevButtonsState);
    }
  }

  function validateEmailForm(emailForm, template) {

    if(template == null){
      dispatch(openModal({ type: 'warning', message: 'Por favor, selecione um template.' }));
      return false;
    }

    if (emailForm.addresses.length === 0) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, adicione um destinatário.' }));
      return false;
    }
    if (template.templateTypeId !== SmsFormTypeIds.internal_email && (!emailForm.subject || emailForm.subject.trim() === '')) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, adicione um assunto.' }));
      return false;
    }
    if (!emailForm.templateId) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, selecione um template.' }));
      return false;
    }
    if (template.templateTypeId !== SmsFormTypeIds.external_email) {
      if (!emailForm.contentEmail || emailForm.contentEmail.trim().length === 0) {
        dispatch(openModal({ type: 'warning', message: 'Por favor, adicione um comentário.' }));
        return false;
      }
    }
    return true;
  }

  //Gestiona el bloqueod/desbloqueo del caso
  function changeBlock(e) {
    if (e.detail > 1) {
      return;
    }
    setReloadTaxonomies(false);

    dispatch(isCaseBlockedByUser({ query: `?caseId=${currentCase.caseId}` })).then((data) => {
      if (data.payload) {
        if (currentCase.blockedByUser) {
          dispatch(unBlockCase(currentCase.caseId)).then(() => {});
        } else {
          dispatch(blockCase(currentCase.caseId)).then(() => {});
        }
      } else if (data.payload === false) {
        dispatch(openModal({ type: 'warning', message: 'O caso está bloqueado por outro usuário.' }));
      }
    });
  }

  //Gestiona el mostrar un formulario de caso nuevo
  function handleShowNewCase() {
    if (!showNewCase == true) {
      props.handleNewCase(true);
      dispatch(newCase())
        .unwrap()
        .then((data) => {
          setClosed(false);
          dispatch(clearTaxonomyFields());
          dispatch(removeActiveHistory());
          setShowNewCase(!showNewCase);
          setDisabledButtom((prevState) => ({ ...prevState, documentation: false, messageForm: true }));
        })
        .catch((error) => {
          return;
        });
    } else {
      dispatch(clearCurrentCase());
      if (previousActive) {
        dispatch(getContractByCaseId({ query: `?caseId=${previousActive.caseId}` }));
        setAllButtonsToState({ disabled: false });
      }
      setShowNewCase(!showNewCase);
    }
  }

  function setAllButtonsToState(value) {
    const buttonsObject = { ...disabledButtom };
    const allButtons = Object.keys(buttonsObject);
    allButtons.forEach((button) => {
      buttonsObject[button] = value.disabled;
    });
    setDisabledButtom(buttonsObject);
  }

  function handleCaseComment(value) {
    const allowedChars = deleteStrangeCharacters(value);
    setCaseComment(allowedChars);
    dispatch(updateCaseForm({ currentComment: value }));
  }

  function handleChangeCaseNumber(value) {
    setCaseNumber(value);
    dispatch(updateCaseForm({ caseNumber: value }));
  }

  function handleChangeAdditionalInfo(value) {
    setAdditionalInfo(value);
    dispatch(updateCaseForm({ additionalInfo: value }));
  }

  function handleChangeScheduleDate(e) {
    setScheduleDate(e);
    const date = dayjs(e).format('YYYY-MM-DDTHH:mm:ss');
    dispatch(updateCaseForm({ scheduleDate: date }));
  }

  function handleChangeCaseState(e) {
    setCaseStateValue(e);
    dispatch(setPreviousCaseState({ changed: true, value: currentCase.stateId }));
    dispatch(updateCaseForm({ stateId: e }));
    dispatch(updateExceptionChecked(false));
  }
  function handleChangeEntryChannel(e) {
    setEntryChannel(e);
    dispatch(updateCaseForm({ entryChannelId: e }));
  }

  function handleChangeScaleDate(e) {
    setScaleDate(e);
    const date = dayjs(e).format('YYYY-MM-DDTHH:mm:ss');
    dispatch(updateCaseForm({ scaleDate: date }));
  }

  function handleChangeFactoryCloseDate(e) {
    setFactoryCloseDate(e);
    const date = dayjs(e).format('YYYY-MM-DDTHH:mm:ss');
    dispatch(updateCaseForm({ factoryCloseDate: date }));
  }

  function handleChangeNonPPReason(e) {
    setNonPPReason(e);
    dispatch(updateCaseForm({ nonPPReason: e }));
  }

  function handleChangeResolution(e) {
    let value;

    if ((actionResolution !== null) & (e.target.value === actionResolution)) {
      e.target.checked = false;
      value = null;
    } else {
      value = e.target.value;
    }

    setActionResolution(value);
    dispatch(updateCaseForm({ actionResolutionId: value }));
  }

  function handleChangeSubState(e) {
    if (e) {
      if (caseStateValue === e.parentStateId) {
        setSubStateValue(e.subStateId);
        dispatch(updateCaseForm({ subStateId: e.subStateId }));
      } else {
        setSubStateValue(null);
        dispatch(updateCaseForm({ subStateId: null }));
      }
    } else {
      setSubStateValue(null);
      dispatch(updateCaseForm({ subStateId: null }));
    }

    dispatch(updateExceptionChecked(false));
  }

  //limpia el valor de subestado al cambiar el estado
  useEffect(() => {
    if (currentCase) {
      if (Array.isArray(caseStateOptions)) {
        const hasSubstate = caseStateOptions.find((o) => o.stateId == caseStateValue && o.subStates.some((sub) => sub.subStateId === subState));
        if (!hasSubstate) {
          setSubStateValue(null);
          dispatch(updateCaseForm({ subStateId: null }));
        }
      }
    }
  }, [caseStateValue]);

  function handleChangeClickToCall(e) {
    let inputNumber = e.target.value;
    //let nonDigitsRegExp = /\D/gm;
    let nonDigitsRegExp = /[^\d+]/gm;
    const filteredNumber = inputNumber.replace(nonDigitsRegExp, '');

    setPhoneNumber(filteredNumber);
  }

  //Gestiona el cambio de estado de taxonomías
  function handleTaxonomyChange(value, level) {
    let newState = { level, [`taxonomyLevel_${level}`]: value };

    for (let i = level + 1; i <= 5; i++) {
      newState[`taxonomyLevel_${i}`] = '';
    }
    setTaxonomyValues((prevState) => ({
      ...prevState,
      ...newState,
    }));
  }

  function checkBlockClickToCall(e) {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    dispatch(isCaseBlockedByUser({ query: `?caseId=${currentCase.caseId}` })).then((data) => {
      if (data.payload) {
        window.open(e.nativeEvent.target.href);
      } else if (data.payload === false) {
        dispatch(openModal({ type: 'warning', message: 'O caso está bloqueado por outro usuário.' }));
      }
    });
  }

  //Envía formulario de crear caso y refresca la store en caso de éxito

  async function handleCreateCase(e) {
    if (e.detail > 1) {
      return;
    }
    setReloadTaxonomies(false);
    const createParams = {
      caseId: 0,
      taxonomyLevel_1: taxonomyValues.taxonomyLevel_1,
      taxonomyLevel_2: taxonomyValues.taxonomyLevel_2 !== '' ? taxonomyValues.taxonomyLevel_2 : null,
      taxonomyLevel_3: taxonomyValues.taxonomyLevel_3 !== '' ? taxonomyValues.taxonomyLevel_3 : null,
      taxonomyLevel_4: taxonomyValues.taxonomyLevel_4 !== '' ? taxonomyValues.taxonomyLevel_4 : null,
      scheduleDate: scheduleDate ? convertToUTC(scheduleDate) : null,
      stateId: caseStateValue,
      subStateId: subState,
      comment: currentCase.currentComment || comment,
      plate: contract.plate,
      CNPJ: contract.customerCNPJ,
      additionalInfo: additionalInfo,
      caseNumber: caseNumber == '' ? null : caseNumber,
      entryChannelId: entryChannel,
      callId: callId,
      scaleDate: scaleDate ? convertToUTC(scaleDate) : null,
      factoryCloseDate: factoryCloseDate ? convertToUTC(factoryCloseDate) : null,
      nonPPReason: nonPPReason,
      actionResolutionId: actionResolution ? Number(actionResolution) : null,
      workshopSearchResult: workshopSearch,
    };

    if (
      (caseStateValue === currentCase.casePreviousState?.firstState || caseStateValue !== currentCase.casePreviousState?.stateChanged) &&
      !contract?.unassigned &&
      contract?.exceptions.length > 0 &&
      !contract?.checkedExceptions
    ) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, confirme que leu as exceções.' }));
    } else if (
      caseStateValue !== null &&
      caseStateValue !== '' &&
      currentCase.currentComment != null &&
      currentCase.currentComment != '' &&
      entryChannel != null &&
      entryChannel != '' &&
      entryChannel != 0
    ) {
      let defaultIdtProcessId = contract.case.idtProcessId ? contract.case.idtProcessId : null;

      dispatch(createCase({ body: createParams })).then((data) => {
        if (data.error) {
          dispatch(openModal({ type: 'warning', message: data.error.message }));
        } else {
          setCaseComment('');
          setShowNewCase(false);
          setShowDocumentation(false);
          dispatch(updateExceptionChecked(false));
          if (defaultIdtProcessId && !data.payload.idtProcessId) dispatch(attachIdtProcessToCase({ body: { idtProcessId: defaultIdtProcessId, caseId: data.payload.caseId } }));
        }
      });
    } else {
      if (entryChannel == null || entryChannel == '' || entryChannel == 0) {
        dispatch(openModal({ type: 'warning', message: "O campo 'Canal de entrada' é obrigatório." }));
      } else {
        let mensaje = caseStateValue == null || caseStateValue === '' ? 'O status é obrigatório.' : 'O campo comentários é obrigatório.';
        dispatch(openModal({ type: 'warning', message: mensaje }));
      }
    }
  }

  async function updatePauData(dataDoct) {
    const contractHasPauData = contract.contractData ? true : false;
    const hasNewMobilePhone = contractHasPauData && dataDoct.number && dataDoct.number.trim() !== contract.contractData?.mobilePhone;
    const updatedEmail = contractHasPauData && dataDoct.email && dataDoct?.email?.trim().toLowerCase() != contract.contractData?.email?.toLowerCase();
    if (((!contractHasPauData || hasNewMobilePhone) && updatePauPhone) || (contract.contractData && updatedEmail && dataDoct.sendMail)) {
      const submitData = {
        contractDataId: contract.contractData?.contractDataId,
        userName: contract.contractData?.userName,
        userSurnames: contract.contractData?.userSurnames,
        mobilePhone: hasNewMobilePhone || !contractHasPauData ? dataDoct.number : contract.contractData?.mobilePhone,
        phone: contract.contractData?.phone,
        email: updatedEmail ? dataDoct.email : contract.contractData?.email,
        driversClub: contract.contractData?.driversClub,
        driversClubDate: contract.contractData?.driversClubDate ? dayjs(contract.contractData?.driversClubDate, 'DD/MM/YYYY').format('YYYY/MM/DD') : null,
        kilometrage: contract.contractData?.kilometrage,
        licenseNumber: contract.contractData?.licenseNumber,
      };

      await dispatch(updateContractData({ param: contract.id, body: submitData }));
    }
  }

  //Envía formulario de actualizar caso y refresca la store en caso de éxito

  async function handleUpdateCase(e) {
    if (e.detail > 1) {
      return;
    }
    setReloadTaxonomies(false);
    const updateParams = {
      caseId: currentCase.caseId,
      taxonomyLevel_1: taxonomyValues.taxonomyLevel_1,
      taxonomyLevel_2: taxonomyValues.taxonomyLevel_2 !== '' ? taxonomyValues.taxonomyLevel_2 : null,
      taxonomyLevel_3: taxonomyValues.taxonomyLevel_3 !== '' ? taxonomyValues.taxonomyLevel_3 : null,
      taxonomyLevel_4: taxonomyValues.taxonomyLevel_4 !== '' ? taxonomyValues.taxonomyLevel_4 : null,
      scheduleDate: scheduleDate ? convertToUTC(scheduleDate) : null,
      stateId: caseStateValue,
      subStateId: subState,
      comment: currentCase.currentComment || comment,
      additionalInfo: additionalInfo,
      caseNumber: caseNumber == '' ? null : caseNumber,
      plate: contract.unassigned ? null : contract.plate || null,
      CNPJ: contract.customerCNPJ || null,
      entryChannelId: entryChannel,
      scaleDate: scaleDate ? convertToUTC(scaleDate) : null,
      factoryCloseDate: factoryCloseDate ? convertToUTC(factoryCloseDate) : null,
      nonPPReason: nonPPReason,
      actionResolutionId: actionResolution ? Number(actionResolution) : null,
      workshopSearchResult: workshopSearch,
    };

    //if ((!contract.plate || contract.unassigned) && !currentCase.withoutPlate) {
    if ((!contract.customerCNPJ || contract.unassigned) && !currentCase.withoutCNPJ) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, salve a matrícula ou marque a opção de sem matrícula.' }));
    } else if (caseStateValue !== currentCase.casePreviousState?.stateChanged && contract.exceptions?.length > 0 && !contract.checkedExceptions && !contract?.unassigned) {
      dispatch(openModal({ type: 'warning', message: 'Por favor, confirme que leu as exceções.' }));
    } else if (
      currentCase.currentComment != null &&
      currentCase.currentComment != '' &&
      entryChannel != null &&
      entryChannel != '' &&
      entryChannel != 0 &&
      (contract.customerCNPJ || !contract.unassigned || currentCase.withoutPlate)
      //(contract.plate || !contract.unassigned || currentCase.withoutPlate)
    ) {
      dispatch(updateCase({ body: updateParams }));
      dispatch(updateExceptionChecked(false));
    } else if (entryChannel == null || entryChannel == '' || entryChannel == 0) {
      dispatch(openModal({ type: 'warning', message: "O campo 'Canal de entrada' é obrigatório." }));
    } else {
      dispatch(openModal({ type: 'warning', message: 'O campo comentários é obrigatório.' }));
    }
  }
  // Carga valores iniciales cada vez que se cambia el caso:

  useEffect(() => {
    if (currentCase && loadingCase !== 'loading') {
      if (currentCase.showFactoryApiErrorCreating) {
        dispatch(openModal({ type: 'warning', message: 'Não foi possível criar o caso na fábrica. A ação será executada automaticamente mais tarde.' }));
      }
    }
    if (!currentCase) {
      setshowMessageForm(false);
      setShowDocumentation(false);
      setShowNewCase(showNewCase ? showNewCase : false);
      // setAllButtonsToState({disabled: true})
      setAllButtonsToState({ disabled: true });
    }
    if (loadingCase !== 'loading' && currentCase != null && reloadTaxonomies) {
      setshowMessageForm(false);
      setShowDocumentation(false);
      //if (contract.plate && !contract.unassigned){
      if (contract.customerCNPJ && !contract.unassigned) {
        setAllButtonsToState({ disabled: false });
      }
      // if (currentCase.withoutPlate) {
      //   setDisabledButtom((prevState) => ({ ...prevState, documentation: true }));
      // }
      if (!currentCase.caseNumber || !currentCase.factoryInteractionAllowed) {
        setDisabledRegressCase(true);
      } else {
        setDisabledRegressCase(false);
      }
      if (!currentCase.factoryInteractionAllowed) {
        setDisabledButtom((prevState) => ({ ...prevState, advanceFactoryCase: true }));
      }

      setAdditionalInfo(currentCase.additionalInfo == null ? '' : currentCase.additionalInfo);
      setCaseNumber(currentCase.caseNumber == null ? '' : currentCase.caseNumber);
      setEntryChannel(currentCase.entryChannelId ? currentCase.entryChannelId : '');
      setPhoneNumber(currentCase.phoneNumber ? currentCase.phoneNumber : '');
      if (currentCase.caseId > 0) {
        setShowNewCase(false);
        
        if (contract.case.stateId == CaseStates.CLOSED) {
        //if (contract.case.stateId == CaseStates.CLOSED || contract.case.stateId == CaseStates.FACTORY_PROCESS || contract.case.stateId == CaseStates.FACTORY_PROCESS_RETURN) {
          setDisabledButtom((prevState) => ({ ...prevState, documentation: true }));
        } else {
          setDisabledButtom((prevState) => ({ ...prevState, documentation: false }));
        }
        

      } else {
        setDisabledButtom((prevState) => ({ ...prevState, messageForm: true }));
      }

      dispatch(getCaseStates());
      dispatch(getTemplates());
      dispatch(getEntryChannels());
      dispatch(getActionResolutions());

      const initialDataSms = {
        number:
          currentCase != null && currentCase.phoneNumber != null
            ? currentCase.phoneNumber
            : contract.contractData == null || !contract.contractData?.mobilePhone || contract.contractData?.mobilePhone.trim() === ''
            ? contract.customerPhone == null
              ? ''
              : contract.customerPhone
            : contract.contractData.mobilePhone,
        plate: contract.plate != null ? contract.plate : '',
        contentSms: '',
        template: templates[0],
        workshopId: '',
        appointmentDate: null,
      };
      const shouldUpdatePauPhoneWhenSaving = initialDataSms.number !== currentCase.phoneNumber;
      setUpdatePauPhone(shouldUpdatePauPhoneWhenSaving);

      setDataSms((prevState) => ({ ...prevState, ...initialDataSms }));

      setDataEmailForm((prevState) => ({
        ...prevState,
        phoneNumber:
          currentCase != null && currentCase.phoneNumber != null
            ? currentCase.phoneNumber
            : contract.contractData == null
            ? contract.customerPhone == null
              ? ''
              : contract.customerPhone
            : contract.contractData.mobilePhone,
        plate: contract.plate != null ? contract.plate : '',
        name: contract.contractData?.userName || '',
        surnames: contract.contractData?.userSurnames || '',
        attachments: [],
      }));

      setDataForm({
        email: contract.contractData?.email ? contract.contractData.email : '',
        name: contract.contractData?.userName || '',
        surname: contract.contractData?.userSurnames || '',
        phoneNumber: contract.contractData?.mobilePhone || phoneNumber,
        tyreSize: '',
        orangeLightPilot: false,
        itvBonus: false,
        originalDocItv: false,
        numberOfTyres: 2,
      });

      for (let i = 1; i <= 5; i++) {
        if (i === 1 || currentCase[`taxonomyLevel_${i}`]) {
          dispatch(
            postTaxonomy({
              body: {
                level: i,
                visible: true,
                taxonomyLevel_1: currentCase.taxonomyLevel_1 ? currentCase.taxonomyLevel_1.key : null,
                taxonomyLevel_2: currentCase.taxonomyLevel_2 ? currentCase.taxonomyLevel_2.key : null,
                taxonomyLevel_3: currentCase.taxonomyLevel_3 ? currentCase.taxonomyLevel_3.key : null,
                taxonomyLevel_4: currentCase.taxonomyLevel_4 ? currentCase.taxonomyLevel_4.key : null,
              },
            })
          );
        }
      }

      setTaxonomyValues((prevState) => ({
        ...prevState,
        ...{
          taxonomyLevel_1: currentCase.taxonomyLevel_1 ? currentCase.taxonomyLevel_1.key : null,
          taxonomyLevel_2: currentCase.taxonomyLevel_2 ? currentCase.taxonomyLevel_2.key : null,
          taxonomyLevel_3: currentCase.taxonomyLevel_3 ? currentCase.taxonomyLevel_3.key : null,
          taxonomyLevel_4: currentCase.taxonomyLevel_4 ? currentCase.taxonomyLevel_4.key : null,
        },
      }));

      setCaseStateValue(currentCase.stateId);
      setSubStateValue(currentCase.subStateId);
      dispatch(setPreviousCaseState({ changed: false, value: currentCase.stateId }));
      setScheduleDate(currentCase.scheduleDate ? convertToLocalTime(currentCase.scheduleDate) : null);
      setCaseComment('');
      setScaleDate(currentCase.scaleDate ? convertToLocalTime(currentCase.scaleDate) : null);
      setFactoryCloseDate(currentCase.factoryCloseDate ? convertToLocalTime(currentCase.factoryCloseDate) : null);
      setNonPPReason(currentCase.nonPPReason == null ? '' : currentCase.nonPPReason);
      setActionResolution(currentCase.actionResolutionId?.toString() || null);
    }

    setReloadTaxonomies(true);
  }, [currentCase?.caseId, loadingCase, contract.unassigned]);

  useEffect(() => {
    if (Object.keys(workshopTypes.workshopTypes).length == 0) {
      dispatch(getWorkshopTypes());
    }
  }, [contract]);

  // Cada vez que se cambia el valor de la taxonomía de un nivel, carga los valores del siguiente nivel de taxonomía
  useEffect(() => {
    if (taxonomyValues.level) {
      if (taxonomyValues.level <= 4) {
        dispatch(
          postTaxonomy({
            body: {
              visible: true,
              level: taxonomyValues.level < 4 ? taxonomyValues.level + 1 : taxonomyValues.level,
              taxonomyLevel_1: taxonomyValues.taxonomyLevel_1,
              taxonomyLevel_2: taxonomyValues.taxonomyLevel_2,
              taxonomyLevel_3: taxonomyValues.taxonomyLevel_3,
              taxonomyLevel_4: taxonomyValues.taxonomyLevel_4,
            },
          })
        );
      }
      let level = taxonomyValues.level;
      if (taxonomyOptions[`level_${level}`]) {
        let updateTax = {};
        let taxonomyWithDescription = taxonomyOptions[`level_${level}`].find((o) => o.key === taxonomyValues[`taxonomyLevel_${level}`]);
        if (taxonomyWithDescription === undefined) {
          taxonomyWithDescription = { key: null, value: null, parentKey: null };
        }
        updateTax[`taxonomyLevel_${level}`] = taxonomyWithDescription;

        for (let i = level + 1; i <= 4; i++) {
          updateTax[`taxonomyLevel_${i}`] = { key: null, value: null, parentKey: null };
        }

        dispatch(updateCaseForm(updateTax));
      }
    }
  }, [taxonomyValues]);

  useEffect(() => {
    if (loadingWorkshopSearch == 'succeeded') {
      setDataSms((prevState) => ({
        ...prevState,
        workshopId: '',
      }));
    }
  }, [loadingWorkshopSearch]);

  useEffect(() => {
    if (caseStateOptionsLoading === 'succeeded' && contract.case) {
      setClosed(isClosed(contract.case.stateId));
    }
  }, [caseStateOptionsLoading, contract.case]);

  //Mira si el caso esta encerrado
  function isClosed(state = null) {
    let closed = false;
    if (state === 4) {
      closed = true;
    }
    return closed;
  }

  //Edita el campo click to call

  useEffect(() => {
    if (editClickToCall) {
      document.getElementById('input-click-to-call').focus();
    }
  }, [editClickToCall]);

  useEffect(() => {
    if (closed) {
      cancelEditClickToCall();
    }
  }, [closed]);

  function validateClickToCall() {
    if (!phoneNumber) {
      return false;
    }
    return phoneNumber.match(/^[0-9+]*$/gm);
    //return phoneNumber.match(/^\+\d$/gm);
  }

  function saveClickToCall() {
    if (!validateClickToCall(phoneNumber)) {
      //dispatch(openModal({ type: 'warning', message: 'Por favor, insira um número de telefone válido com o código internacional (+55) e 11 dígitos (DDD + número).' }));
      dispatch(openModal({ type: 'warning', message: 'Por favor, insira um número de telefone válido.' }));

      return;
    }

    dispatch(updateClickToCall({ query: `?caseId=${currentCase.caseId}&newNumber=${encodeURIComponent(phoneNumber)}` }));
    setEditClickToCall(false);
  }

  function cancelEditClickToCall() {
    setPhoneNumber(currentCase.phoneNumber);
    setEditClickToCall(false);
  }

  function handleChangeSendEmailForm(field, value) {
    setDataEmailForm((prevState) => ({ ...prevState, [field]: value }));
  }

  async function getEmailRecipientByTemplate(template) {
    if (template) {
      try {
        const recipientData = await baseRequest({ query: `?templateCode=${template.templateCode}` }, dispatch, QUERY_GET_EMAIL_FROM_TEMPLATE, 'POST');

        if (recipientData.value.length === 0 && template.templateTypeId !== SmsFormTypeIds.internal_email) {
          setDataEmailForm((prevState) => ({ ...prevState, email: contract?.contractData?.email ? contract.contractData.email : '' }));
        } else {
          const resultToString = recipientData.value
            .filter((emailRecipient) => {
              return !emailRecipient.isCC;
            })
            .map((emailRecipient) => emailRecipient.emailAddress)
            .join('; ');
          const ccEmails = recipientData.value
            .filter((emailRecipient) => {
              return emailRecipient.isCC;
            })
            .map((emailRecipient) => emailRecipient.emailAddress)
            .join('; ');
          setDataEmailForm((prevState) => ({ ...prevState, email: resultToString, cc: ccEmails }));
        }
      } catch (error) {}
    }
  }

  //carga la lista de destinatarios del email en función de la taxonomía del caso
  useEffect(() => {
    getEmailRecipientByTemplate(dataEmailForm.template);
  }, [dataEmailForm.template, showMessageForm]);

  useEffect(() => {
    if (!showMessageForm) {
      setDataEmailForm((prevState) => ({
        ...prevState,
        template: null,
        subject: '',
        attachments: [],
      }));
    }
  }, [showMessageForm]);

  return (
    <div className="caseform-section caseform-grid">
      <Header
        phoneNumber={phoneNumber}
        saveClickToCall={saveClickToCall}
        cancelEditClickToCall={cancelEditClickToCall}
        editClickToCall={editClickToCall}
        setEditClickToCall={setEditClickToCall}
        handleChangeClickToCall={handleChangeClickToCall}
        checkBlockClickToCall={checkBlockClickToCall}
        showCallTable={contract?.case}
        showMessageForm={showMessageForm}
        showDocumentation={showDocumentation}
        showAdvanceFactoryCaseForm={showAdvanceFactoryCaseForm}
        showAddFactoryCommentForm={showAddFactoryCommentForm}
        showRegressFactoryCaseForm={showRegressFactoryCaseForm}
        handleShowForms={handleShowForms}
        changeBlock={changeBlock}
        plate={contract.plate}
        CNPJ={contract.customerCNPJ}
        closed={closed}
        setShowNewCase={handleShowNewCase}
        showNewCase={showNewCase}
        loading={loadingCase}
        currentCase={currentCase}
        createCase={handleCreateCase}
        saveChanges={handleUpdateCase}
        disabledButtom={disabledButtom}
        disabledRegressCase={disabledRegressCase}
      />
      <div id="test" style={{ position: 'relative' }} className="cases-container">
        <MessageForm
          workshopFilters={workshopFilters}
          workshopSearch={workshopSearch}
          disabledSms={disabledButtom.messageForm}
          handleTemplateChange={handleTemplateChange}
          templates={templates}
          dataSms={dataSms}
          dataEmailForm={dataEmailForm}
          handleShowForms={handleShowForms}
          handleSendSmsForm={handleSendSmsForm}
          handleSendEmailForm={handleSendEmailForm}
          handleChangeEmailForm={handleChangeSendEmailForm}
          handleChangeSendSMSForm={handleChangeSendSMSForm}
          showMessageForm={showMessageForm}
          setReplacedSms={setReplacedSms}
          replacedSms={replacedSms}
        ></MessageForm>
        <DocumentationForm
          disabledButtom={disabledButtom.documentation}
          dataDocumentation={dataDocumentation}
          setDataEmailForm={setDataEmailForm}
          setAllButtonsToState={setAllButtonsToState}
          setDisabledButtom={setDisabledButtom}
          phoneNumber={phoneNumber}
          showDocumentation={showDocumentation}
          dataSms={dataSms}
          handleShowForms={handleShowForms}
        ></DocumentationForm>
        {contract?.case ? <CallTable handleShowForms={handleShowForms} showCallTable={showCallTable} contractCalls={contract?.case?.calls} contractEmails={contract?.case?.emails}></CallTable> : <></>}
        {(currentCase != null && Object.keys(currentCase).length !== 0 && currentCase.caseId != undefined && currentCase.caseId > 0) || showNewCase ? (
          <>
            <AddFactoryCommentForm
              currentCaseId={currentCase?.caseId}
              processId={currentCase?.factoryProcessId}
              expedient={currentCase?.caseNumber}
              handleShowForms={handleShowForms}
              showAddFactoryCommentForm={showAddFactoryCommentForm}
              setShowAddFactoryCommentForm={setShowAddFactoryCommentForm}
              formClassName={'factory-header-form'}
            />
            <AdvanceFactoryCaseForm
              setDisabledButtom={setDisabledButtom}
              handleShowForms={handleShowForms}
              showRegressFactoryCaseForm={showRegressFactoryCaseForm}
              setShowRegressFactoryCaseForm={setShowRegressFactoryCaseForm}
              showAdvanceFactoryCaseForm={showAdvanceFactoryCaseForm}
              setShowAdvanceFactoryCaseForm={setShowAdvanceFactoryCaseForm}
            />
            <TaxonomyForm
              closed={closed}
              loading={loadingCase === 'idle' || loadingCase === 'loading' ? true : false}
              taxonomyValues={taxonomyValues}
              taxonomyOptions={taxonomyOptions}
              caseOptions={caseStateOptions}
              entryChannelsOptions={entryChannelsOptions}
              caseValue={caseStateValue}
              dateValue={scheduleDate}
              additionalInfo={additionalInfo}
              caseNumber={caseNumber}
              entryChannelValue={entryChannel}
              factoryCloseDateValue={factoryCloseDate}
              scaleDateValue={scaleDate}
              nonPPReasonValue={nonPPReason}
              changeTaxonomy={handleTaxonomyChange}
              changeCaseValue={handleChangeCaseState}
              changeDate={handleChangeScheduleDate}
              changeAdditionalInfo={handleChangeAdditionalInfo}
              changeCaseNumber={handleChangeCaseNumber}
              changeEntryChannel={handleChangeEntryChannel}
              changeFactoryCloseDate={handleChangeFactoryCloseDate}
              changeScaleDate={handleChangeScaleDate}
              changeNonPPReason={handleChangeNonPPReason}
              changeSubState={handleChangeSubState}
              subStateValue={subState}
            />
            <CommentSection
              showNewCase={showNewCase}
              closed={closed}
              loading={loadingCase === 'idle' || loadingCase === 'loading' ? true : false}
              comments={currentCase ? currentCase.comments : null}
              current={(currentCase && currentCase.currentComment) || comment}
              changeCaseComment={handleCaseComment}
              resolution={actionResolution}
              resolutionOptions={actionResolutionOptions}
              changeResolution={handleChangeResolution}
            />
          </>
        ) : (
          <>
            <NoneSelectedMessage message={'Nenhum chamado selecionado.'} />
          </>
        )}
      </div>
    </div>
  );
}

export { CaseWrapper };
